exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.loading[data-v-3b28b1fe] {\n  font-size: 30px;\n  margin-bottom: 20px;\n}\n.subscription-msg[data-v-3b28b1fe] {\n  margin: 0 auto;\n  max-width: 25rem;\n  width: 100%;\n  min-height: 15.625rem;\n  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.06);\n  border-radius: 0.5rem;\n  padding: 2rem 1.5rem;\n}\n.subscription-msg .btn + .btn[data-v-3b28b1fe] {\n  margin-left: 1.5em;\n}\n.btn-learn-more[data-v-3b28b1fe] {\n  background: none;\n  border: none;\n  color: #00a9f0;\n  text-decoration: underline;\n}\n.btn-learn-more[data-v-3b28b1fe]:hover {\n  color: #0084bc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-3b28b1fe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/revenue/Rules.vue
// module id = 3078
// module chunks = 0